<template>
  <div>
    <data-table ref="dataTable" :option="option">
      <template slot="rowAction" slot-scope="text, record">
        <!-- <a-button type="link" v-if="!record.IsGroup" @click="update(record)"
          >升级</a-button
        >
        <a-button type="link" v-if="record.IsGroup" @click="update(record)"
          >降级</a-button
        >
        <a-divider type="vertical" /> -->
        <a-button type="link" @click="edit(record.Id)" v-if="record.IsGroup"
          >编辑</a-button
        >
        <a-button
          type="link"
          @click="checkInfo(record.Id)"
          v-if="!record.IsGroup"
          >查看</a-button
        >
        <a-divider v-if="record.IsGroup" type="vertical" />
        <a-popconfirm
          placement="bottomRight"
          okText="确认"
          cancelText="取消"
          @confirm="del(record.Id)"
          v-if="record.IsGroup"
        >
          <template slot="title">
            <p>您确认删除吗？</p>
          </template>
          <a-button type="link" size="small">
            删除
          </a-button>
        </a-popconfirm>
      </template>
    </data-table>
  </div>
</template>
<script>
import { cache } from "@/utils/common";
import { DataTable } from "@/components/dataTable";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      user: null,
      form: this.$form.createForm(this),
      visible: {
        maskClosable: false,
        showModal: false
      },
      CompanyId: "",
      salesManData: [],
      isGroup: false
    };
  },
  created() {
    this.user = cache.get("user");
    const _this = this;
    this.CompanyId = this.user.CompanyId;
    const content = [
      {
        label: "客户名称",
        name: "Name",
        option: {
          rules: [{ required: true, message: "请输入客户名称!" }]
        }
      },
      {
        label: "客户编号",
        name: "Code",
        option: {
          rules: [{ required: true, message: "请输入客户编号!" }]
        }
      },
      {
        label: "客户类型",
        name: "CustomerTypeId",
        placeholder: "请选择客户类型",
        type: "select",
        api: "GetGroupSelectItems",
        param: { Types: "G_CustomerType", CompanyId: _this.CompanyId },
        valueField: "Id",
        textField: "Text",
        dataField: "Data.G_CustomerType",
        option: {
          rules: [{ required: true, message: "请选择客户类型!" }]
        }
      },
      {
        label: "客户简称",
        name: "ShortName"
      },
      {
        label: "合同号",
        name: "ContractNo"
      },
      {
        label: "所属门店",
        name: "CompanyName",
        props: {
          disabled: true
        }
      },
      {
        label: "销售员",
        name: "SalesmanId",
        placeholder: "请选择销售员",
        type: "select",
        width: "160px",
        api: "GetGroupSelectItems",
        param: { Types: "Salesman", CompanyId: _this.CompanyId },
        valueField: "Id",
        textField: "Text",
        dataField: "Data.Salesman",
        option: {
          rules: [{ required: true, message: "请选择销售员!" }]
        }
      },
      {
        label: "挂账标志",
        name: "OfferCreditSign",
        placeholder: "请选择挂账标志",
        type: "select",
        api: "GetGroupSelectItems",
        param: { Types: "OfferCreditSign" },
        valueField: "Id",
        textField: "Text",
        dataField: "Data.OfferCreditSign",
        option: {
          rules: [{ required: true, message: "请选择挂账标志!" }]
        }
      },
      {
        label: "联系人",
        name: "Contacts"
      },
      {
        label: "联系电话",
        name: "ContactsInfo"
      },
      {
        label: "总限额",
        name: "TotalLimit"
      },
      {
        label: "单次限额",
        name: "SingleTimeLimit"
      },
      {
        label: "截止日期",
        colnum: 2,
        type: "date-range-picker",
        name: "DateRange",
        min: moment(_this.user.AccountDate, "YYYY-MM-DD")
      }
    ];
    const editContent = cloneDeep(content);
    editContent[editContent.length - 1].props = {};
    this.option = {
      headSearch: {
        colnum: 3,
        content: [
          {
            label: "门店",
            name: "CompanyId",
            placeholder: "请选择所属分店",
            type: "select",
            api: "GetGroupSelectItems",
            param: { Types: "companycontaingroup" },
            valueField: "Id",
            textField: "Text",
            dataField: "Data.companycontaingroup",
            width: "150px",
            onChange: (value, sel) => {
              _this.handleChangeSearch(value, sel);
            }
          },
          {
            label: "挂账标志",
            name: "OfferCreditSign",
            placeholder: "请选择挂账标志",
            type: "select",
            api: "GetGroupSelectItems",
            param: { Types: "OfferCreditSign" },
            valueField: "Id",
            textField: "Text",
            dataField: "Data.OfferCreditSign",
            width: "150px"
          },
          {
            label: "关键字",
            name: "Name",
            placeholder: "请输入客户名称/简称等"
          }
        ]
      },
      form: {
        title: "用户",
        width: 1000,
        colnum: 3,
        content: content,
        add: {
          submitApi: "GroupCustomer_Add",
          onOpenBefore: () => {
            this.isGroup = true;
            _this.CompanyId = _this.user.CompanyId;
            _this.$nextTick(() => {
              _this.setCustomerTypeData(_this.CompanyId, "");
              _this.setSalesManData(_this.CompanyId, "");
            });
          },
          onOpenAfter: () => {
            return { CompanyName: _this.user.CompanyName };
          },
          onSubmitBefore: values => {
            return this.onBeforeSubmitAdd(values);
          }
        },
        edit: {
          infoApi: "GroupCustomer_GetClient",
          submitApi: "GroupCustomer_Edit",
          content: editContent,
          onOpenBefore: value => {
            return value;
          },
          onOpenAfter: res => {
            const data = res.Data;
            const DateRange = [];
            if (data.StartTime) {
              DateRange.push(moment(data.StartTime, "YYYY-MM-DD"));
            }
            if (data.EndTime) {
              DateRange.push(moment(data.EndTime, "YYYY-MM-DD"));
            }
            if (DateRange.length) {
              data.DateRange = DateRange;
            }
            _this.CompanyId = data.CompanyId;
            _this.$nextTick(() => {
              _this.setCustomerTypeData(data.CompanyId, data.CustomerTypeId);
              _this.setSalesManData(data.CompanyId, data.SalesmanId);
            });

            return data;
          },
          onSubmitBefore: values => {
            return this.onBeforeSubmitEdit(values);
          }
        },
        del: {
          submitApi: "GroupCustomer_Delete"
        }
      },
      grid: {
        api: "GroupCustomer_List",
        columns: [
          {
            title: "序号",
            width: 50,
            type: "indexcolumn"
          },
          {
            title: "客户名称",
            width: 100,
            dataIndex: "Name",
            align: "center"
          },
          {
            title: "客户编号",
            width: 100,
            dataIndex: "Code"
          },
          {
            title: "客户类型",
            width: 80,
            dataIndex: "CustomerTypeName"
          },
          {
            title: "简称",
            width: 100,
            dataIndex: "ShortName"
          },
          {
            title: "所属门店",
            width: 150,
            dataIndex: "CustomerAffiliationName"
          },
          {
            title: "挂账标志",
            width: 80,
            dataIndex: "OfferCreditSign",
            customRender: text => {
              if (text == "1") {
                return "挂账";
              } else if (text == "2") {
                return "禁用";
              } else {
                return "协议";
              }
            }
          },
          {
            title: "联系人",
            width: 80,
            dataIndex: "Contacts"
          },
          {
            title: "电话",
            width: 100,
            dataIndex: "ContactsInfo"
          },
          {
            title: "总限额",
            width: 80,
            dataIndex: "TotalLimit",
            align: "right"
          },
          {
            title: "单次限额",
            width: 80,
            dataIndex: "SingleTimeLimit",
            align: "right"
          },
          {
            title: "余额",
            width: 80,
            align: "right",
            dataIndex: "Rest"
          },
          {
            title: "截止日期",
            width: 100,
            dataIndex: "EndTime"
          },
          {
            title: "操作",
            dataIndex: "Id",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    handleChangeSearch(value, sel) {
      const form = this.$refs.dataTable.getRef("headSearchForm");
      form.form.setFieldsValue({ CustomerTypeId: "" });
      this.isGroup = sel ? sel.BackUpBool : false;
      this.setCustomerTypeData(value, "", form);
    },
    //根据门店获取客户类型
    setCustomerTypeData(value, id, formObj) {
      this.$nextTick(() => {
        const form = formObj ? formObj : this.$refs.dataTable.getForm();
        const customerType = this.isGroup ? "G_CustomerType" : "CustomerType";
        if (value == "") {
          form.setFieldData("CustomerTypeId", []);
        } else {
          this.$post("GetGroupSelectItems", {
            Types: customerType,
            CompanyId: value
          }).then(res => {
            if (this.isGroup) {
              form.setFieldData("CustomerTypeId", res.Data.G_CustomerType);
            } else {
              form.setFieldData("CustomerTypeId", res.Data.CustomerType);
            }

            form.form.setFieldsValue({ CustomerTypeId: id });
          });
        }
      });
    },
    //根据门店获取销售员
    setSalesManData(value, id) {
      this.$nextTick(() => {
        const form = this.$refs.dataTable.getForm();
        this.$post("GetGroupSelectItems", {
          Types: "Salesman",
          CompanyId: value
        }).then(res => {
          form.setFieldData("SalesmanId", res.Data.Salesman);
          this.salesManData = res.Data.Salesman;
          const saleId = id == "" ? res.Data.Salesman[0].Id : id;
          form.form.setFieldsValue({ SalesmanId: saleId });
        });
      });
    },
    onBeforeSubmitEdit(values) {
      values = {
        ...values,
        StartTime:
          values.DateRange.length && values.DateRange[0]
            ? moment(values.DateRange[0]).format("YYYY-MM-DD")
            : "",
        EndTime:
          values.DateRange.length > 1
            ? moment(values.DateRange[1]).format("YYYY-MM-DD")
            : ""
      };
      values.CompanyId = this.CompanyId;
      const res = this.getSalesmanName(values.SalesmanId);
      if (res) {
        values.Salesman = res;
      }
      return values;
    },
    onBeforeSubmitAdd(values) {
      values = {
        ...values,
        StartTime:
          values.DateRange.length && values.DateRange[0]
            ? moment(values.DateRange[0]).format("YYYY-MM-DD")
            : "",
        EndTime:
          values.DateRange.length > 1
            ? moment(values.DateRange[1]).format("YYYY-MM-DD")
            : ""
      };
      values.CompanyId = this.CompanyId;
      delete values["DateRange"];
      const res = this.getSalesmanName(values.SalesmanId);
      if (res) {
        values.Salesman = res;
      }
      return values;
    },
    getSalesmanName(id) {
      const result = this.salesManData.find(item => item.Id == id);
      return result ? result.Text : false;
    },
    onAction() {
      this.visible.showModal = true;
    },
    getSelected() {
      // const row = this.$refs.dataTable.getSelected();
    },
    getGridData() {
      // const data = this.$refs.dataTable.getGridData();
    },
    edit(id) {
      this.isGroup = true;
      this.setFieldsStatus(false);
      this.$refs.dataTable.edit(id);
    },
    checkInfo(id) {
      this.isGroup = false;
      this.setFieldsStatus(true);
      this.$refs.dataTable.edit(id);
    },
    setFieldsStatus(flag) {
      const fields = [
        "Name",
        "Code",
        "CustomerTypeId",
        "ShortName",
        "ContractNo",
        "SalesmanId",
        "OfferCreditSign",
        "Contacts",
        "ContactsInfo",
        "TotalLimit",
        "SingleTimeLimit",
        "DateRange"
      ];
      const newContent = this.$refs.dataTable.formOption.edit.content.map(
        item => {
          if (fields.indexOf(item.name) > -1) {
            if (item.props && typeof item.props === "object") {
              item.props.disabled = flag;
            } else {
              item.props = {
                disabled: flag
              };
            }
          }
          return item;
        }
      );
      this.$refs.dataTable.formOption.edit.content = newContent;
    },
    del(id) {
      this.$refs.dataTable.del({ Id: id });
    },
    // update(record) {
    //   this.$post("GroupCustomer_Update", {
    //     Id: record.Id,
    //     IsGroup: record.IsGroup
    //   }).then(res => {
    //     this.$message.success(res.Message);
    //     this.$refs.dataTable.headSearch();
    //   });
    // },
    disabledStartDate(StartTime) {
      const EndTime = this.EndTime;
      if (!EndTime) {
        return StartTime < moment(this.user.AccountDate).startOf("day");
      } else {
        return (
          StartTime.valueOf() > EndTime.valueOf() ||
          StartTime < moment(this.user.AccountDate).startOf("day")
        );
      }
    },
    disabledEndDate(EndTime) {
      const StartTime = this.StartTime;
      if (!StartTime) {
        return (
          EndTime <
          moment(this.user.AccountDate)
            .add(1, "d")
            .startOf("day")
        );
      } else {
        return StartTime.valueOf() >= EndTime.valueOf();
      }
    }
  }
};
</script>

<style></style>
